import { USER_PROFILE } from "./UserProfileRequestParams";

export const LIKE = `
author {
  _id
  profile {
    ${USER_PROFILE}
  }
}`;
